import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M14.58 1.84L1.84 14.58a.297.297 0 11-.42-.42L14.16 1.42a.297.297 0 01.42.42z" fill="#12033D" /><path d="M1.84 1.42l12.74 12.74a.295.295 0 010 .42.295.295 0 01-.42 0L1.42 1.84a.297.297 0 01.42-.42z" fill="#12033D" /></svg>;